import { put } from 'redux-saga/effects'

import { updateProfileRequested } from '~/profile/model/actions'
import { updateShipper } from '~/basket/model/session/actions'

import { logException } from '~/logging'

export function* handleLoadDefaultShipper() {
  try {
    yield put(updateProfileRequested())
  } catch (error) {
    logException(error)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* handleUpdateProfileSuccess(action: any) {
  try {
    yield put(updateShipper(action.payload.profile))
  } catch (error) {
    logException(error)
  }
}
